module.exports = __webpack_public_path__ + "static/media/management_nora_blake2.bc03ac97.png";